export default __webpack_public_path__ + "static/media/logo-minc-novo.56f3b9cc.svg";